import React from 'react'

const FormSubmission = () => {
  return (
    <div className='flex flex-col items-center justify-center text-center gap-8 w-full min-h-screen px-4 sm:px-16 md:px-32 lg:px-80 mx-auto'
            style={{
                backgroundImage: 'radial-gradient(gray 0px, transparent 1px)',
                backgroundSize: '20px 20px'
            }}
        >
            <div className='text-2xl sm:text-4xl md:text-4xl font-bold tracking-tighter capitalize'>
                <h2>Thank you for contacting Querencia Micro Credit!</h2>
            </div>
            <div className='font-light'>
                <p className='-tracking-tighter lg:px-24 mx-auto'>a member of our team will be in touch with you shortly.</p>
            </div>
            <p className='underline text-center text-base font-semibold text-blue-400'><a href='/'><em>Click here to return to the homepage.</em></a></p>
        </div>
  )
}

export default FormSubmission